export default "__VITE_ASSET__7z$i2Yn4__"